import type { AssetPositionGroup } from "kubb";

import {
  type Option,
  flattenNestedLists,
} from "../Forms/SelectCombo/SelectCombo";

function assetPositionGroupToOptions(
  group: AssetPositionGroup,
  level: number,
): Option[] {
  const thisLevel = {
    value: group.group,
    label: group.group,
  };
  if (group.children) {
    return [
      thisLevel,
      ...assetPositionGroupListToOptions(group.children, level + 1),
    ];
  } else {
    return [thisLevel];
  }
}

export function assetPositionGroupListToOptions(
  assetPositionGroups: AssetPositionGroup[],
  level: number,
): Option[] {
  return flattenNestedLists(
    assetPositionGroups.map((value) => {
      return assetPositionGroupToOptions(value, level);
    }),
  );
}
